<template>
  <div>
    <v-layout fill-height="" style="background-color: white;" v-if="!$vuetify.breakpoint.smAndDown">
      <v-card color="white" flat width="100%" v-if="resources.length > 0">
        <v-carousel style="position:absolute;" height="690px" hide-delimiters show-arrows-on-hover v-model="activeOption" :show-arrows="false">
        
          <v-carousel-item v-for="(res, index) in resources" :key="index">
            <vue-three-sixty
                style="height:700px;width:100%;max-height:100%"
                :amount=res.additionalUrls.length
                :imagePath="Get360ProductBaseImagePath(res)"
                :fileName="Get360ProductImageName(res)"
                containerHeight="640px"
                :autoplay="true"
            />
          </v-carousel-item>
        </v-carousel>
        <div v-if="resources.length > 1" style="height:690px;">
        <v-btn style="position:absolute;top:50%;left:5px" class="mt-2"  rounded center dark @click="OnTapPrev()" :disabled="activeOption == 0">
          <v-icon left>
            mdi-chevron-left
          </v-icon>
          PREV ARTEFACT
          </v-btn>
          <v-btn style="position:absolute;top:50%;right:5px" class="mt-2" rounded center dark @click="OnTapNext()" :disabled="resources.length - 1 == activeOption">
          <v-icon left>
            mdi-chevron-right
          </v-icon>
          NEXT ARTEFACT
          </v-btn>
        </div>
      </v-card>
      <v-card height="778px" width="100%" v-else style="position:absolute;right:94px">
        <v-img contain
          style="height:100%;width:100%"
          :src="asset.resources.find(r => r.tags.includes('Landing')).url"
        >
        </v-img>
      </v-card>
      
    </v-layout >
    <v-card color="white" style="position:fixed;bottom:56px;top:0px;left:0px;right:0px;" ref="holder" v-else>
      <v-carousel style="position:absolute;" :touchless="true" :height="viewerHeight + 'px'" hide-delimiters show-arrows-on-hover v-model="activeOption" :show-arrows="false" v-if="calculatedHeight" :key="reRenderCaro">
          <v-carousel-item v-for="(res, index) in resources" :key="index">
            <vue-three-sixty
                :style="viewerStyle"
                :amount=res.additionalUrls.length
                :imagePath="Get360ProductBaseImagePath(res)"
                :fileName="Get360ProductImageName(res)"
                :containerHeight="viewerHeight - 50 + 'px'"
                :autoplay="true"
            />
          </v-carousel-item>
        </v-carousel>
        <div v-if="resources.length > 1">
        <v-btn small fab style="position:absolute;top:50%;left:5px"  rounded center dark @click="OnTapPrev()" :disabled="activeOption == 0">
          <v-icon>
            mdi-chevron-left
          </v-icon>
          </v-btn>
          <v-btn small fab style="position:absolute;top:50%;right:5px"  rounded center dark @click="OnTapNext()" :disabled="resources.length - 1 == activeOption">
          <v-icon>
            mdi-chevron-right
          </v-icon>
          </v-btn>
        </div>
    </v-card>
</div>
</template>

<script>
  export default {
    name: 'ThreeSixtyResourcesView',
    components: {
    },
    props: {

      resources : null,
      asset : null

    },
    computed: {

      height () 
      {


      },
      viewerStyle() {

        return "height:" + this.viewerHeight + "px;width:100%;max-height:100%";

      }

     
    },

    mounted () {

      window.addEventListener('resize', this.ResizeEvent);

      this.$nextTick(() => {
        if(this.$refs.holder != null)
        {
          this.viewerHeight = this.$refs.holder.$el.clientHeight;
          this.calculatedHeight = true;
        }
      })

    },
    data: () => ({

      activeOption : 0,
      viewerHeight : 100,
      calculatedHeight : false,
      reRenderCaro : 0

    }),
    methods: {

      ResizeEvent()
      {
        if(this.$vuetify.breakpoint.smAndDown)
        {
          clearTimeout(this.$options.resizeTimer);
          this.$options.resizeTimer = setTimeout(this.FinishedResizing, 100);
        }
       
      },
      FinishedResizing()
      {

        if(this.$refs.holder != null)
        {
          this.viewerHeight = this.$refs.holder.$el.clientHeight;
          this.calculatedHeight = true;
          this.reRenderCaro += 1;
        }
      },
      OnTapNext()
      {
        this.activeOption++;
      },
      OnTapPrev()
      {
        this.activeOption--;
      },
      Get360ProductBaseImagePath(resource)
      {
          var upToLastDirectory = resource.url.substring(0,resource.url.lastIndexOf("/"));
          return upToLastDirectory;
      },
      Get360ProductImageName(resource)
      {
          var extension = resource.name.split('.')[1];
          var name = resource.id + "-" + resource.name.substring(0,resource.name.lastIndexOf("_"));
          name += "_{index}." + extension;
          return name;
      }

    },
    watch: {
      
    }
  }
</script>

<style>

.v360-fullscreen-toggle
{
  visibility: hidden;
}

</style>
